import React from 'react';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';
import { Member } from '@/api/bol';

export interface MemberDeleteDialogProps {
  open: boolean;
  member: Member | null;
  onClose: () => void;
  onDelete: (identifier: string) => Promise<void>;
}

export const MemberDeleteDialog: React.FC<MemberDeleteDialogProps> = ({
  open,
  member,
  onClose,
  onDelete
}) => {
  const handleDelete = async () => {
    if (member?.identifier) {
      await onDelete(member.identifier);
    }
  };

  return (
    <DeleteConfirmDialog
      open={open}
      title="Remove Member"
      itemType="member"
      itemId={member?.identifier || null}
      onClose={onClose}
      onConfirm={handleDelete}
    />
  );
};